/**
 * DrilldownModal — overlay hosting a DrilldownGrid for one metric. Rendered
 * from inside a widget (thus inside the DashboardProvider), so the grid
 * inherits the dashboard's site/time/department scope.
 */
import React from 'react';
import { X } from 'lucide-react';
import DrilldownGrid from './DrilldownGrid';

export default function DrilldownModal({
  open, metric, title, extraDimensions = null, siteOverride = null,
  timeOverride = null, subtitle = null, onClose,
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 p-4 sm:p-8"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="w-full max-w-5xl rounded-lg bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-start justify-between gap-4">
          <div className="min-w-0">
            <h2 className="text-lg font-semibold text-gray-900">{title || 'Records'}</h2>
            {subtitle && <p className="mt-0.5 text-xs text-gray-500">{subtitle}</p>}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <DrilldownGrid
          metric={metric}
          title={title}
          extraDimensions={extraDimensions}
          siteOverride={siteOverride}
          timeOverride={timeOverride}
        />
      </div>
    </div>
  );
}
